// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@eisinc/Overrides/Widgets/ProductList/ProductListCardList";
import { color, xScreen } from "@eisinc/XDL/Utilities";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";

listStyles.wrapper = {
    css: css`
        [data-test-selector="productListCards_List"] {
            display: grid;
            grid-template-columns: 1fr;
        }
        [data-test-selector="productListCards_Grid"] {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(317px, 1fr));
            gap: 24px 22px;
            ${xScreen("lte", "md")} {
                grid-template-columns: repeat(auto-fill, minmax(328px, 1fr));
                gap: 0 20px;
            }
        }
    `,
};

listStyles.centeringWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
    `,
};

listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            margin: 0;
            border-bottom: 1px solid ${color("common.border")};
            width: 100%;
            > ${GridItemStyle} {
                padding: 0;
                padding-bottom: 12px;
            }
            &:not(:first-child) > ${GridItemStyle} {
                padding-top: 12px;
            }
        `,
    },
};
